import React, { PureComponent } from 'react';
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Text } from 'recharts';
import moment from 'moment';
export default class MonthlyDeliveryVolumnBarChart extends PureComponent {

  constructor(props){
    super(props);
    let data = props.data? props.data : null;
    let title = props.title? props.title : null;
    let barList = props.barList ? props.barList : [];
    let axisType = props.axisType ? props.axisType : 'number';
    let dataMax = props.dataMax ? props.dataMax : [0, 'dataMax+40'];
    let prefixValue = props.prefixValue ? props.prefixValue : '';
    let subfixValue = props.subfixValue ? props.subfixValue : '';
    let leftMargin = props.leftMargin ? props.leftMargin : 20;
    
    this.state = {
      data : data,
      title: title,
      barList: barList,
      dataMax: dataMax,
      axisType: axisType,
      prefixValue: prefixValue,
      subfixValue: subfixValue,
      leftMargin: leftMargin
    }
  }
  
  formatYAxis = (value) => {
    value = this.state.title == 'average_drops_per_day' ? parseInt(value).toLocaleString() : parseFloat(value).toFixed(2).toLocaleString(undefined, { useGrouping: true });
    if(this.state.prefixValue != '' || this.state.subfixValue != '') {
      return this.state.prefixValue+''+parseFloat(value).toLocaleString()+''+this.state.subfixValue;
    } else {
      return parseFloat(value).toLocaleString();
    }        
  }

  render() {
    return (
      <div className='w-100' style={{overflowX: 'auto', overflowY: 'hidden', height: 'auto'}}>
        {this.state.data && this.state.data.length > 0 ?
        <BarChart
          width={750}
          height={300}
          data={this.state.data}
          margin={{
            top: 5,
            right: 20,
            left: this.state.leftMargin,
            bottom: 100,
          }}
          className='legend-padding-bar overflow-hidden'
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis  dataKey="name"  type="category" interval={0} />
          <YAxis type="number" />
          <Tooltip />
          {/* { this.state.axisType == 'number' && <Legend align='center' verticalAlign='top' iconType="square"
           wrapperStyle={{
              paddingBottom: "25px"
          }}/>} */}
          <Bar dataKey={moment().subtract(3, 'year').year()} barSize={20} fill={'#376FEB'} />
          <Bar dataKey={moment().subtract(2, 'year').year()} barSize={20} fill={'#C9C9C9'} />
          <Bar dataKey={moment().subtract(1, 'year').year()} barSize={20} fill={'#FCAC42'} />
          <Bar dataKey={moment().year()} barSize={20} fill={'#3151AA'} />
        </BarChart> :
        <div className="d-flex justify-content-center align-items-center">There is no Data for date range !!</div>}
      </div>
    );
  }
}
